interface WarningToastProps {
  title: string;
  message: string;
}

export const WarningToast = ({ title, message }: WarningToastProps) => {
  return (
    <div className='flex items-center gap-6'>
      <div className='w-16 h-16 flex justify-center items-center bg-[#D2E3EA] rounded-md'>
        <svg className='w-10 h-10 text-primary-600' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z'
          />
        </svg>
      </div>
      <div>
        <h2 className='font-semibold text-primary-600'>{title}</h2>
        <p className='text-primary-400'>{message}</p>
      </div>
    </div>
  );
};
